module.exports = __webpack_public_path__ + "media/img/frontend_application/stats/icon-clicked-2e9861d7d0a01a824935c599c4ca05ba.png";